import { Card, CardBody, Col } from "reactstrap";
import { FontStyle } from "../../../../Constant";
import { FONT_DATA, FONT_STYLE } from "../../../../Data/UiKit/HelperClasses";
import { P } from "../../../../AbstractElements";
import CommonCardHeader from "../../../../Common/CommonCardHeader";
const FontStyleCart = () => {
  return (
    <Col xl="6">
      <Card className="height-equal">
        <CommonCardHeader title={FontStyle} span={FONT_DATA} />
        <CardBody>
          <P className="f-s-normal">This is a .f-s-normal font-style</P>
          {FONT_STYLE.map((item, index) => (
            <P className={item} key={index}>{`This is a .${item} font-style `}</P>
          ))}
        </CardBody>
      </Card>
    </Col>
  );
};

export default FontStyleCart;
